const userSession = (attribute) => {
  if (localStorage.getItem('user'))
    return JSON.parse(localStorage.getItem('user'))[attribute];
  return null;
};

export default userSession;
